export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70fdc8598738a580368b6655b30b9c6a46ae74eb5c&name=pushAdClickData!'